<!-- sku预分拣记录明细(参考销售情况) -->
<template>
  <div>
    <Drawer v-model="isShow" width="550px;" title="需打包数详情" :closable="false">
      <Input
        v-model="searchParam.innerNo"
        suffix="ios-search"
        placeholder="输入订单编号搜索"
        clearable
        @on-enter="getSearch()"
        @on-clear="onClear()"
      />
      <br />
      <br />
      <Table stripe :columns="pcheader" :data="list" @on-sort-change="sortCallBack" :loading="tableLoading"> </Table>
      <br />
      <Page :total="total" :page-size="searchParam.rows" @on-change="changesList" ref="pages" />

      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="isShow = false">返回</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
const CONSTANT = require("../../../common/const");
import { queryPreSortingDetailBySku } from "@/api/sorting/preSorting";
import { getHasSortingUnitAndBaseUnit } from "@/libs/util";
export default {
  name: "orderBoxList",
  props: {},
  data() {
    return {
      CONSTANT,
      tableLoading: false,
      isShow: false,
      // 搜索刷选条件
      search: {
        // 时间段筛选
        type: "daterange",
        searchitem: [{ name: "名称", key: "title", type: "input", inputtype: "", value: "" }],
        // 是否显示添加按钮；
        addbutton: false,
        // 是否显示重置按钮
        reset: true
      },
      searchParam: {
        page: 1,
        rows: 10,
        innerNo: "" // 订单编号
      },
      /** 表头 */
      pcheader: [
        {
          title: "订单编号",
          key: "inner_no",
          align: "center",
          minWidth: 120
        },
        {
          title: "需打包数量",
          key: "showNum",
          align: "center",
          minWidth: 120,
          sortable: "custom"
        }
      ],
      list: [],
      total: 0,
      currentSku: {}
    };
  },
  methods: {
    showDrawer(param, currentSku) {
      this.searchParam = {
        ...param,
        page: 1,
        rows: 10
      };
      this.currentSku = currentSku;
      this.isShow = true;
      this.getList();
    },
    changesList(page) {
      this.$set(this.searchParam, "page", page);
      this.getList();
    },
    getSearch() {
      this.getList();
    },
    // 排序回调
    sortCallBack(column) {
      if (column.order != "normal") {
        let sortData = [column.key, column.order];
        this.searchParam.sortData = sortData;
      } else {
        delete this.searchParam.sortData;
      }
      this.getList();
    },
    onClear() {
      this.$set(this.searchParam, "innerNo", "");
      this.getList();
    },
    getList() {
      this.tableLoading = true;
      return new Promise((resolve, reject) => {
        queryPreSortingDetailBySku(this.searchParam).then(res => {
          if (res.status === 200) {
            this.total = res.data.data.count;
            let list = res.data.data.rows;
            for (let item of list) {
              if (item.is_weight == 1) {
                // 计重
                item.showNum = getHasSortingUnitAndBaseUnit({
                  weightG: item.weight,
                  base_unit: this.currentSku.base_unit ? this.currentSku.base_unit : "",
                  unit: this.currentSku.auxiliary_unit ? this.currentSku.auxiliary_unit : "",
                  unit_conversion: this.currentSku.unit_conversion,
                  is_weight: this.currentSku.is_weight
                }).showUnit;
              }
              if (item.is_weight == 2) {
                // 不计重
                item.showNum = getHasSortingUnitAndBaseUnit({
                  weightG: item.product_num,
                  base_unit: this.currentSku.base_unit ? this.currentSku.base_unit : "",
                  unit: this.currentSku.auxiliary_unit ? this.currentSku.auxiliary_unit : "",
                  unit_conversion: this.currentSku.unit_conversion,
                  is_weight: this.currentSku.is_weight
                }).showUnit;
              }
            }
            this.list = list;
          }
          this.tableLoading = false;
        });
      }).catch(err => {
        console.log(err);
        this.$Message.error(err);
      });
    }
  },
  mounted() {},
  watch: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/view/sorting/preSortingDetail.vue